import camelCase from 'lodash-es/camelCase';

import { LICENSE_COLORS, STATUSES } from '@/constants';
import formatLicenseTypeText from '@/utils/formatLicenseTypeText';

/**
 * Get the color class associated to a specific value.
 *
 * @param type The type of data we're processing. Each type has different enums
 * @param value the value used to find the color in the enum provided
 */
export default function generateColorClass(type: string, value: string) {
  let color;

  try {
    switch (type) {
      case 'license':
        value = formatLicenseTypeText(value);
        color = LICENSE_COLORS[value];
        break;
      case 'order':
        color = 'tw-bg-' + STATUSES.ORDER_WITH_DELIVERED[value.toUpperCase()].color;
        break;
      case 'certified-seller':
        color = STATUSES.SELLER_STATUSES[camelCase(value)].color;
        break;
      case 'inbound-leads':
        color = STATUSES.INBOUND_LEADS[value.toUpperCase()].color;
        break;
    }

    return color || 'tw-bg-ice-500';
  } catch (e) {
    return 'tw-bg-ice-500';
  }
}
